import {
  FETCH_SAVED_CARDS,
  FETCH_SAVED_CARDS_SUCCESS,
  FETCH_SAVED_CARDS_FAILURE,
  SAVE_CARD,
  SAVE_CARD_SUCCESS,
  SAVE_CARD_FAILURE,
  PROCESS_PAYMENT,
  PROCESS_PAYMENT_SUCCESS,
  PROCESS_PAYMENT_FAILURE,
  CREATE_SETUP_INTENT,
  CREATE_SETUP_INTENT_FAILURE,
  CREATE_SETUP_INTENT_SUCCESS,
} from "../types/StripeCardTypes";

interface StripeCardState {
  savedCards: any[];
  loading: boolean;
  error: string | null;
  paymentSuccess: boolean;
  clientSecret: string | null;
}

const initialState: StripeCardState = {
  savedCards: [],
  loading: false,
  error: null,
  paymentSuccess: false,
  clientSecret: null,
};

export const stripeCardReducer = (
  state = initialState,
  action: any
): StripeCardState => {
  switch (action.type) {
    case FETCH_SAVED_CARDS:
    case SAVE_CARD:
    case PROCESS_PAYMENT:
      return { ...state, loading: true, error: null, paymentSuccess: false };

    case FETCH_SAVED_CARDS_SUCCESS:
      return { ...state, loading: false, savedCards: action.payload };

    case SAVE_CARD_SUCCESS:
      return { ...state, loading: false };

    case PROCESS_PAYMENT_SUCCESS:
      return { ...state, loading: false, paymentSuccess: true };

    case FETCH_SAVED_CARDS_FAILURE:
    case SAVE_CARD_FAILURE:
    case PROCESS_PAYMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_SETUP_INTENT:
      return { ...state, loading: true, error: null, paymentSuccess: false };

    case CREATE_SETUP_INTENT_SUCCESS:
      return { ...state, loading: false, clientSecret: action.payload };

    case CREATE_SETUP_INTENT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
